import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  parent: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  container: {
    backgroundColor: "white",
    borderRadius: "4px",
    width: "18rem",
  },
  title: {
    fontSize: theme.typography.pxToRem(14),
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    border: "none",
    "&.MuiInput-underline:hover:not(.Mui-disabled):before": {
      border: "none",
    },
    "&.MuiInput-underline:before": {
      border: "none",
    },
    "&.MuiInput-underline:after": {
      border: "none",
    },
  },
  hiddenMenuItem: {
    display: "none",
  },
  header: {
    backgroundColor: "#F1F5F9",
    margin: "20px 0",
    padding: "0 0 0 20px",
    textAlign: "center",
    alignContent: "center",
    height: "2rem",
    justifyContent: "space-between",
    display: "flex",
  },
  calendar: {
    width: "100%",
    justifyContent: "space-between",
    display: "flex",
    padding: "0 12px",
    textAlign: "center",
    "&.is-readonly button": {
      cursor: "default",
    },
  },
  calendarItem: {
    width: "calc(100% / 7)",
  },
  current: {
    border: "1px solid black",
  },
  selected: {
    "&:hover": {
      backgroundColor: "#00A3A3",
      color: "white",
    },
    backgroundColor: "#00A3A3 !important",
    color: "white !important",
  },
  weekDay: {
    marginBottom: "10px",
    width: "calc(100% / 7)",
    height: "75%",
    fontSize: theme.typography.pxToRem(14),
  },
  day: {
    borderRadius: "100%",
    padding: "7px 8px",
    margin: "10px 3px",
    fontSize: theme.typography.pxToRem(14),
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
}));
